import React, { Component } from "react";

import {
  Modal, ChoiceList,Badge,Spinner, Banner
} from "@shopify/polaris";
import { reqGetExportRecords,reqExportRedirects } from "../../api";

import { API_OSS } from '../../utils/constants';

// import utils from '../../utils/utils';

import Language from '../../i18n/Language';
import ExportRecordModal from "../ExportRecordModal";
import { showNewMessage } from '@intercom/messenger-js-sdk';
const t = Language

class ExportRedirectActionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ExportActive:props.ExportActive,
      ExportActiveLoading: false,
      ExportSelected:'0',
      OpenExportRecordLoading:false,
      OpenImportRecordLoading:false,
      //Export 窗口
      ExportRecordActive: false,
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.ExportActive !== this.state.ExportActive) {
      let ExportActive = nextProps.ExportActive;
      this.setState({
        ExportActive: ExportActive,
      })
    }
    // if(nextProps.domain !== this.props.domain){
    //   this.setState({
    //     domain:nextProps.domain
    //   })
    // }
    return true
  }

  //关闭弹窗
  CloseExport=()=>{
    this.props.CloseExport()
  }

  // shopify 自带input框 、 Chioce List 组件的更新值得方法
  handleInputChange = (value,name) => {
    this.setState({ 
      [name]: value
    });
  }

  //打开Export Record窗口
  OpenExportRecord = async (activeState=true) => {

    this.setState({OpenExportRecordLoading:true});

    const response = await reqGetExportRecords();

    if (response.code === 200) {
      var redirectRecords = response.data;
      var recordRows = [];
      var isPolling = false;
      if(redirectRecords){
        redirectRecords.forEach((item, index) => {
          var action ='Expired';
          if(!item.is_del){
            action = <a href= {API_OSS+'/export/BrokenLink/'+item.name+'?v=1'} rel="noopener noreferrer" target="_blank" download="item.name" >{t("download")}</a>
          }
          var status = <Badge tone="success">{t("Finish")}</Badge>
          if (!item.status) {
            isPolling = true;
            status = <Badge tone="info">{t("Processing")}</Badge>
            action = <Spinner size="small" />;
          }
          recordRows.push(
            [item.name,item.count,item.export_at,status,action]
          )
        })
      }
      
      if(activeState) {
         this.CloseExport()
        this.setState({
          ExportRecordActive: true,
          recordRows:recordRows
        });
      } else {
        this.setState({
          recordRows:recordRows
        });
      }
      setTimeout(() => {
        if (isPolling && this.state.ExportRecordActive) {
          this.OpenExportRecord(false)
        }
      },2000)
    } 

    this.setState({OpenExportRecordLoading:false});

  
  };

  //关闭Export Record窗口
  CloseExportRecord = () => {
    this.setState({
      ExportRecordActive: false
    });
  };

  // 导出提交
  handleExportAction = async () => {
    //等级等于0时弹窗
    if (!this.props.userServices.BrokenLinkImportExport) {
      this.props.openUpgradeModelShow()
      return "";
    }else{
      this.setState({ExportActiveLoading:true});
      const params = {
        type: this.state.ExportSelected
      };
      const response = await reqExportRedirects(params);
      if (response.code === 200) {
        this.props.toggleToast(t("Success"), false);
        this.OpenExportRecord()
      } else {
        this.setState({
          isShowErrorTip: response.msg,
        })
        // this.props.toggleToast(response.msg, true);
      }

      this.setState({ExportActiveLoading:false});
    }
  };

  //点击联系客服
  handleContactService = ()=>{
    try {
      showNewMessage();
    } catch(e) {
      this.toggleToast(t("Try again later"))
    }
  }


  render() {
    const {
      isShowErrorTip
    } = this.state;
    
    return (
      <div>
        <Modal
        open={this.state.ExportActive}
        onClose={this.CloseExport}
        title={t("Export Redirects")}
        secondaryActions={[
          {
            content: t("Export Records"),
            onAction: this.OpenExportRecord,
            loading: this.state.OpenExportRecordLoading
          },
          {
            content: t("Cancel"),
            onAction: this.CloseExport
          },
        ]}
        primaryAction={[
          {
            content: t("Export"),
            onAction: this.handleExportAction,
            loading: this.state.ExportActiveLoading
          }
        ]}
        
      >
        <Modal.Section>
          {
            isShowErrorTip && <Banner
              title={isShowErrorTip}
              tone="critical"
              action={{
                content: t("Contact us"),
                onAction: this.handleContactService
              }}
              onDismiss={() => {
                this.setState({ isShowErrorTip: false })
              }}
            >
            </Banner>
          }
          
          <p>{t("Your redirects will be exported as a CSV (comma separated values) table.")}</p>
          <ChoiceList
              titleHidden
              choices={[
                {label: t("Export all redirects"), value: '0'},
                {label: t("Export unresolved 404 errors"), value: '1'},
                {label: t("Export solved redirects"), value: '2'},
              ]}
              name="ExportSelected"
              selected={this.state.ExportSelected}
              onChange={this.handleInputChange}
            />
        </Modal.Section>
      </Modal>
      <ExportRecordModal ExportRecordActive={this.state.ExportRecordActive} recordRows={this.state.recordRows} CloseExportRecord={this.CloseExportRecord} />
    </div>
    );
  }
}

export default ExportRedirectActionModal;